export default __webpack_public_path__ + "static/x-red-8ff17584ab4935a68d1db79d01618674.png";